import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import fakeData from '../../fakeData';
import { getDatabaseCart, removeFromDatabaseCart,processOrder } from '../../utilities/databaseManager';
import Cart from '../Cart/Cart';
import happyImage from '../../images/giphy.gif';

import ReviewItem from '../RevuewItem/ReviewItem';

const Review = () => {
      const [cart, setCart] = useState([]);
      const [orderPlace,setOrderPlace] = useState(false);

      const handlePlaceOrder = () => {
            setCart([]);
            setOrderPlace(true);
            processOrder();
      }



      const removeProduct = (productKey) =>{
            const newCart = cart.filter(pd =>pd.key !== productKey);
            setCart(newCart);
            removeFromDatabaseCart(productKey)
      }

useEffect(() => {
      const savedCart = getDatabaseCart();
      const productKeys = Object.keys(savedCart);

      const cartProducts = productKeys.map( key => {
            const product = fakeData.find( pd =>pd.key === key);
            product.quantity = savedCart[key];
            return product;
            
      });
      setCart(cartProducts);
}, []);
let thankYou;
if(orderPlace)
{
      thankYou =<img src={happyImage} alt="" />
} 

      return (
            <div className="twin-container">
                 <div className = "product-container">
                 {
                  cart.map(pd => <ReviewItem 
                        key = {pd.key }
                        removeProduct = {removeProduct}
                        product={pd}></ReviewItem>)
                 }
                 {
                  thankYou
                 }
                 </div>
                 <div className = "cart-container">
                  <Cart cart = {cart}>
                        <button
                        onClick={handlePlaceOrder}
                        className='mainBtn'
                       
                        >Place Order</button>
                  </Cart>
                  

                 </div>

                
            </div>
      );
};

export default Review;